import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addPeople: {
		id: 'users-and-roles.header.add-people.add-people',
		defaultMessage: 'Add people',
		description: 'Text on the button in the page header which allows the user to add people',
	},
	addPeopleFreeTooltip: {
		id: 'users-and-roles.header.add-people.add-people-free-tooltip',
		defaultMessage: 'On the Free plan you need to add people in site admin.',
		description:
			'Tooltip shown to users on the free plan when they hover over the "Add people" button',
	},
	addPeopleJswFreeTooltip: {
		id: 'users-and-roles.header.add-people.add-people-jsw-free-tooltip',
		defaultMessage:
			"On a free plan, you can only add people using your site's administration settings. Upgrade your plan to better control who can access this project.",
		description:
			'Tooltip shown to users on the free plan when they hover over the "Add people" button',
	},
	addPeopleJsmFreeTooltip: {
		id: 'users-and-roles.header.add-people.add-people-jsm-free-tooltip',
		defaultMessage:
			"On a free plan, you can only add people using your site's administration settings. Upgrade your plan to better control who can access this service project.",
		description:
			'Tooltip shown to users on the free plan when they hover over the "Add people" button',
	},
});
